export default __webpack_public_path__ + "static/media/rocket-ship.9456fe46.png";